export default __webpack_public_path__ + "static/N0016-8d7df639d50fea0c45abad7a4d0dd826.png";